<template>
  <v-btn
    class="text-uppercase"
    v-bind="$attrs"
    variant="flat"
  >
    <!-- Only when given: VBtn draws its icon instead of an empty default slot -->
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TBtn",
});
</script>
